export default __webpack_public_path__ + "static/media/adjustment-layer.d72f6c58.webp";